import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const res = await api.post("/auth/session", { session_id: sessionId });
        window.history.replaceState({}, "", "/host");
        navigate("/host", { state: { user: res.data } });
      } catch (e) {
        navigate("/host/login", { state: { error: e?.response?.data?.detail || "Sign-in failed." } });
      }
    })();
  }, [location, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-cream">
      <div className="text-center animate-fade-in">
        <div className="w-10 h-10 rounded-full border-2 border-gold border-t-transparent animate-spin mx-auto" />
        <p className="mt-4 text-inkSoft text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
